import { render } from "./B2cCheckoutNav.vue?vue&type=template&id=6dcb3204"
import script from "./B2cCheckoutNav.vue?vue&type=script&lang=js"
export * from "./B2cCheckoutNav.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__